module.exports = __webpack_public_path__ + "static/media/rec.5734ad2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rec.svg
// module id = 28
// module chunks = 1